<template class="sgame-odds-box">
    <div class="singleodds" :class="{'is-blocked': outright.status === 'block'}">
        <div class="single-game-outrights">
            <div>
                <div class="single-noodds" v-if="outright.shouldRemove">
                    <img src="../../../assets/img/error-no-odds.svg">
                    <p>{{$t('NOODDSAVAILABLEATTHISMOMENT')}}</p>
                </div>
                <template v-else>
                    <div v-for="marketByName in marketsByNames" class="sgame-odds-box" :key="marketByName.name">
                    <p class="sgame-odds-header">{{marketByName.name | formatModifierName(null, marketByName.specifiers)}}</p>
                        <div class="sgame-odds-container sgame-odds-container-outrights"
                        :key="market.lineHash"
                        v-for="market in marketByName.markets">
                            <div class="sgame-odds-content">
                                <!-- chek if this is needed for em feed -->
                                <!-- <div class="sgame-odd sgame-odd-outrights">
                                    <div class="sgame-odd-value no-odd" >
                                        <template v-if="!market.specifiers">{{market.name}}</template>
                                        <div v-else>
                                            <div v-if="market.specifiers.Competitor">{{market.specifiers.Competitor | formatModifierName(null, market.specifiers)}}</div>
                                            <div v-if="market.specifiers.Round"> krug {{market.specifiers.Round}}</div>
                                            <div>{{market.specifiers.player | formatModifierName(null, market.specifiers)}}</div>
                                        </div>
                                    </div>
                                </div> -->
                                <template v-for="outcome in market.outcomes">
                                    <SingleOutrightOutcome
                                    class="sgame-odd"
                                    v-if="outcome.status == 'block' || outcome.status == 'active'"
                                    :outcome="outcome"
                                    :market="market"
                                    :outright="outright"
                                    :key="outcome.outcomeHash"
                                    :details="true" />
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SingleOutrightOutcome from './SingleOutrightOutcome.vue';

export default
{
    name: 'OutrightOutcomes',
    props: ['outright'],
    components: {
        SingleOutrightOutcome,
    },
    data()
    {
        return {
            up: false,
            down: false,
        };
    },
    methods:
    {
        ...mapActions([
            'selectOutrightOutcome',
        ]),
        isOutcomeSelected(param)
        {
            const {
                outright,
                outcome,
            } = param;

            if (this.betslipItemsMapping[
                `outrights_${outright.outrightsOfferId}_${outcome.outcomeHash}`
            ] != null)
            {
                return true;
            }

            return false;
        },
    },
    computed:
    {
        ...mapGetters([
            'betslipItemsMapping',
        ]),
        marketsByNames()
        {
            const me = this;
            const markets = [];
            const activeOutcomes = [];
            for (const market of me.outright.markets)
            {
                if (market.outcomes.length)
                {
                    market.hasOutcomesToShow = false;

                    for (const outcome of market.outcomes)
                    {
                        if (outcome.status === 'active' || outcome.status === 'block')
                        {
                            market.hasOutcomesToShow = true;
                            activeOutcomes.push(outcome);
                        }
                    }
                }
                const { name } = market;

                if (!markets.includes(name) && market.hasOutcomesToShow)
                {
                    markets.push(name);
                }
            }

            if (!activeOutcomes.length)
            {
                return [];
            }

            const newMarkets = markets.map((item) =>
            {
                const newItem = {};
                newItem.name = item;
                newItem.markets = [];
                return newItem;
            });

            for (const item of newMarkets)
            {
                for (const market of me.outright.markets)
                {
                    if (item.name === market.name && market.hasOutcomesToShow)
                    {
                        item.markets.push(market);
                    }
                }
            }
            return newMarkets;
        },

    },
};
</script>

<style>
.single-game-outrights {
    height: calc(100% - 2rem);
    overflow: auto;
}
</style>
